<template>
  <div class="box">
    <div>
      <img class="pic" src="../assets/ok.png" alt="">
    </div>
    <div class="title">
      恭喜您订购成功
    </div>
    <div class="order">
      您的订单编号：<span>{{ orderNo }}</span>
    </div>
    <div class="msg">
      请注意接听客服电话：<span>{{ servicePhone }}</span>
    </div>
    <!-- <div @click="more" class="more">
      查看更多商品
    </div> -->
  </div>
</template>

<script>
  import { goGdtWx } from "../utils/api"
export default {
  name: 'ordersuccess',
  data () {
    return {
      orderNo:null,
      servicePhone:null,
      orderStay:null,
      wxlink:''
    }
  },
  created(){
    this.orderNo=this.$route.query.order_no
    this.servicePhone=this.$route.query.servicePhone
    this.orderStay=parseInt(this.$route.query.order_stay)
    // goGdtWx().then(res=>{
    //   console.log(res,"我的微信连接")
    // })
    // setTimeout(()=>{
    //   this.more()
    // },this.orderStay)
  },
  methods:{
    more(){
      location.href="weixin://dl/business/?appid=wx778aa3ee3e141b7c&path=pages/index/index&query=&env_version="
    }
  }
}
</script>
<style scoped>
.box{
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  font-size: 20px;
  background: #f8f8f8;
}
.box div{
  margin-bottom: 20px;
}
.title{
  color:red;
  font-size: 22px;
}
.pic{
  width: 140px;
  margin-bottom: 40px;
}
.order{
  font-size: 18px;
}
.order span{
  color:red
}
.msg{
  font-size: 20px;
}
.msg span{
  color:red
}
.more{
  background:#00be2b ;
  font-size: 20px;
  padding:10px;
  color:white;
  border-radius:5px;
}
</style>



// WEBPACK FOOTER //
// src/components/ordersuccess.vue